exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shop-single-item__select-box[data-v-27f5b839] {\n  max-width: 100%;\n}\n.double-input-select__field-gr select[data-v-27f5b839] {\n  color: #1a1a1a;\n}", ""]);

// exports
